import React, { memo, useState } from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { compose } from 'redux';
import { Row, Col, Spin, Table, Drawer, Button, Icon, Modal } from 'antd';
import { useMutation } from 'react-query';
import request from '@utils/request';
import { getUserListAction } from '@/global.actions';
import { makeSelectUserList, makeSelectUserListLoading } from '@/global.selectors';
import UserDetail from './detail';
import { formatNumber } from 'utils/helper';

function UserList({userList, userListLoading, getUserList}) {
  const [selectedUser, setSelectedUser] = useState({});
  const [showCreate, setShowCreate] = useState(false);

  const { isLoading, mutate: getUserToken } = useMutation((id) => {
    if (id) {
      return request.get(`v1/users/${id}/token`);
    }
  },
    {
      onSuccess: (response) => {
        if(response.data.length > 0){
          const {name, token} = response.data[0];
          Modal.success({content: `Mã đăng nhập của ${name}: ${token}`});
        }
      },
    });

  const handleSave = () => {
    setSelectedUser({});
    setShowCreate(false);
    getUserList();
  }
  const handleSelect = (item) => {
    setShowCreate(false);
    setSelectedUser(item);
  }
  const handleGetUserToken = (user) => {
    getUserToken(user.id);
  }
  const renderTotal = (_, rec) => {
    const {basicSalary, allowance} = rec;
    const total = basicSalary + allowance;
    return formatNumber(total);
  }
  const renderAction = (id, rec) => {
    return (
      <>
        <Button icon="edit" onClick={() => handleSelect(rec)} />
        <Button title='Lấy mã đăng nhập' style={{marginLeft: 12}} disabled={isLoading} spinning={isLoading} icon="eye" onClick={() => handleGetUserToken(rec)} />
      </>
    )
  }

  const columns = [
    {
      dataIndex: 'id',
      title: 'Mã NV'
    },
    {
      dataIndex: 'name',
      title: 'Họ Tên'
    },
    {
      dataIndex: 'avatar',
      title: 'Avatar',
      render: text => <img alt="Avatar" src={text} width={50} height={50} />
    },
    {
      dataIndex: 'active',
      title: 'Active',
      render: text => text ? <Icon type="check-circle" theme="twoTone" /> : '',
      sorter: (a, b) => b.active - a.active
    },
    {
      dataIndex: 'bankName',
      title: 'Tên NH',
    },
    {
      dataIndex: 'bankAccount',
      title: 'Số TK',
    },
    {
      dataIndex: 'phone',
      title: 'Điện thoại',
    },
    {
      dataIndex: 'basicSalary',
      title: 'Lương căn bản',
      render: formatNumber
    },
    {
      dataIndex: 'allowance',
      title: 'Phụ cấp',
      render: formatNumber
    },
    {
      title: 'Tổng lương',
      render: renderTotal
    },
    {
      render: renderAction
    },
  ]
  const data = userList.filter(x => x.role > 1).sort((a,b) => b.active - a.active);
  const activeEmployee = data.filter(x => x.active).length;
  const title = showCreate ? 'Thêm thông tin nhân viên' : `Cập nhật thông tin nhân viên ${selectedUser.name}`;
  return (<>
    <Row gutter={16}>
      <Col sm={14}>
        <h2>Nhân Viên ({activeEmployee}/{data.length})</h2>
      </Col>
      <Col sm={10}>
        <Button onClick={() => setShowCreate(true)}>Thêm Nhân Viên</Button>
      </Col>
    </Row>
    <Spin spinning={userListLoading}>
      <Row gutter={16}>
        <Table
          dataSource={data}
          columns={columns}
          rowKey="id" />
      </Row>
    </Spin>
    <Drawer 
      destroyOnClose={true} 
      maskClosable={false} 
      visible={selectedUser.id || showCreate} 
      onClose={handleSelect} 
      width="50%" 
      title={title}>
      <UserDetail
        user={selectedUser}
        onSave={handleSave}
        onCancel={handleSelect}
      />
    </Drawer>
  </>)
}

UserList.propTypes = {
};

UserList.defaultProps = {
};

const mapStateToProps = createStructuredSelector({
  userList: makeSelectUserList(),
  userListLoading: makeSelectUserListLoading(),
});
const mapDispatchToProps = dispatch => ({
  getUserList: () => dispatch(getUserListAction()),
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, memo)(UserList);